
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list/index';
import {
  IJianPaiSCMErrorLogItem,
  IJianPaiSCMErrorLogListReq,
  RECEIVED_PAYMENT_TYPE_LIST,
} from '@/api/jianpai-scm/index.type';
import { getJianPaiSCMErrorLogList } from '@/api/jianpai-scm';
import { formatTime } from '@toy/utils';
import { getLabelByVal } from '@/core/utils/index';

export default defineComponent({
  setup() {
    const {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IJianPaiSCMErrorLogItem, IJianPaiSCMErrorLogListReq>({
      request: {
        api: getJianPaiSCMErrorLogList,
        params: {
          zdh: '',
          bm: '',
          type: '',
          pageNum: 1,
          pageSize: 10,
        },
      },
    });
    handleSearch();
    return {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,

      RECEIVED_PAYMENT_TYPE_LIST,
      getLabelByVal,
      formatTime,
    };
  },
});
